document.addEventListener('DOMContentLoaded', () => {
  function refreshCarouselArrows() {
    document
      .querySelectorAll('[data-testid="product-list"] slideshow-component.resource-list__carousel')
      .forEach((carousel) => {
        // Re-trigger the native 'current' setter now that the browser has
        // finished calculating which slides are visible, so the arrows'
        // disabled state reflects reality instead of the load-time guess.
        carousel.current = carousel.current;
      });
  }

  window.addEventListener('load', () => setTimeout(refreshCarouselArrows, 100));

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshCarouselArrows, 150);
  });
});